import { Button } from '@rematter/ui-web';
import { useAtom } from 'jotai';

import { $loadForm } from '../../_state/loadForm.state';
import { useTranslations } from '../../i18n/useTranslations';
import { LoadFormState } from '../../types/load';

type Props = {
  tab?: 'load-info' | 'materials';
  isSaving?: boolean;
  onSaveUpdates?: (
    tab?: 'load-info' | 'materials',
    data?: LoadFormState,
    onlyDatesAndEntities?: boolean,
  ) => void;
  onDiscard?: (onlyDiscardDatesAndEntities?: boolean) => void;
};

export const LoadFormFooterActions: React.FC<Props> = ({
  tab,
  isSaving,
  onSaveUpdates,
  onDiscard,
}) => {
  const t = useTranslations();

  const [form] = useAtom($loadForm);

  return (
    <div className="@LoadFormFooterActions flex flex-shrink-0 items-center gap-3">
      <Button
        color="neutral"
        variant="outline"
        onPress={() => onDiscard?.()}
        isDisabled={isSaving}
      >
        {t.loadDetail.footer.discard}
      </Button>
      <Button
        color="primary"
        variant="solid"
        onPress={() => {
          onSaveUpdates?.(tab, form);
        }}
        isPending={isSaving}
        isLoading={isSaving}
      >
        {t.loadDetail.footer.saveUpdates}
      </Button>
    </div>
  );
};
